import { useEffect, useRef } from "react";
import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import BookSection from "@/components/BookSection";
import AuthorSection from "@/components/AuthorSection";
import PurchaseSection from "@/components/PurchaseSection";
import Footer from "@/components/Footer";

function App() {
  const sectionsRef = useRef({});

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="app-wrapper">
      <Header onNavigate={scrollToSection} />
      <main>
        <HeroSection onNavigate={scrollToSection} />
        <BookSection />
        <AuthorSection />
        <PurchaseSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
